const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import PeopleGrid from "./layouts/people_grid";
import RotatingTabs from "./layouts/rotating_tabs";
import Featherlight from "./../lib/featherlight";
import Marketo from "./Marketo.class";
import Trustarc from "./Trustarc.class";
import Cookies from 'js-cookie';

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    scrollSpeed;
    #TabsLayout;
    #RotatingTabs;
    #PeopleGrid;
    #marketo;
    #trustarc;
    #utils;

    #counter;

    constructor(
        config,
        builder,
        utils,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;

        this.scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#inPageNav = new InPageNav(this);
        this.#TabsLayout = new TabsLayout(this);
        this.#RotatingTabs = new RotatingTabs(this);
        this.#PeopleGrid = new PeopleGrid(this);
        this.#marketo = new Marketo("670-UQO-512", "calamp.com", "www2.calamp.com", [], [], []);
        this.#trustarc = new Trustarc(this.$body);

        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", 1);
        }

        this.#trustarcIntegration();
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        me.#TabsLayout.events();
        me.#RotatingTabs.events();
        me.#PeopleGrid.events();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function(i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)){
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                }
            }
        });

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "navbars": [
                    {
                        "position": "bottom",
                        "content": [
                            "searchfield"
                        ]
                    }
                ],
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                offCanvas: {
                    pageNodetype: 'div#page.site-wrapper'
                },
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": homeurl
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');

        this.$header.addClass('fixed');
        this.$main.css('padding-top', this.headerHeight + "px");
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
            $(window).trigger("resize");
        }, 1000);

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');
        Utils.equalHeight('.tabbed_section__js', '.tabbed_section');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3000) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: 3000,
                        easing: 'linear',
                        step: function () {
                            $me.text(Utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(Utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $('.single_accordion .single_accordion__header').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $(".image-gallery .kmdg-gallery").featherlightGallery({filter: ".image"});

        if(typeof window.truste === "undefined") {
            Utils.log("Failed to load Trustarc. Implied consent zone assumed.");
            $(window).trigger(this.#trustarc.events.consent.functional);
            $(window).trigger(this.#trustarc.events.consent.advertising);
        }


        // Popout JS
        $('.fieldStatus .fieldStatus__tab').on('click', function () {
            var $column = $(this).parents('.fieldStatus');

            $column.toggleClass('fieldStatus--open');
        });
    }

    __onResize() {
        this.$main.css('padding-top', this.headerHeight + "px");
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    #trustarcIntegration() {
        const self = this;

        $(window).on(this.#trustarc.events.consent.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.consent.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(false, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(false, event.hasRun);
            event.hasRun = true;
        });
    }

    #trustarcFunctional(consent, hasRun) {

        if (consent) {
            if (!hasRun) {
                // Only run this code once
                if (this.#marketo) {
                    const $mktoForms = $("[id^='mktoForm_']");

                    if ($mktoForms.length > 0 && $mktoForms.parents("#modalPopup").length < $mktoForms.length) {
                        this.#marketo.load();
                    }
                }
            }
        } else {
            // No consent
        }
    }

    #trustarcAdvertising(consent, hasRun) {
        if (consent) {
            if (window.VidyardV4) {
                VidyardV4.api.GDPR.consent(true);
                Utils.log("Vidyard: Have tracking consent.");
            } else {
                Utils.log("Vidyard: API not loaded yet.");
            }
        } else {
            // No consent
            if (window.VidyardV4) {
                VidyardV4.api.GDPR.consent(false);
                Utils.log("Vidyard: No tracking consent.");
            } else {
                Utils.log("Vidyard: API not loaded yet.");
            }
        }
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }
}